module.exports = __webpack_public_path__ + "img/happy.d65a0598.svg";